import axios from 'axios'

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getCintillos = () => {
  return axios.get(`${process.env.API_URL}/cintillos`)
}


/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getCarrusel = () => {
  return axios.get(`${process.env.API_URL}/carrusel-home?populate=*`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getBenefits = () => {
  return axios.get(`${process.env.API_URL}/home-benefit?populate=*`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getLearningCenter = () => {
  return axios.get(`${process.env.API_URL}/learning-center?populate[articles][populate][0]=category&populate[articles][populate][1]=featuredImage`)
}


/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getProperties = () => {
  return axios.get(`${process.env.API_URL}/properties?populate=*`)
}